import API from './config'

export const FundLocalQuotasAPI = {
    async saveLocalQuotas(obj) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/saveLocalQuotas', obj, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateLocalJsonQuotas(obj) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/updateLocalJsonQuotas', obj, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async updateInfosLocalQuotas(fundLocalQuotaId, infos) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/fund_local_quotas/updateInfosLocalQuotas', {
                fund_local_quota_id: fundLocalQuotaId,
                infos: infos,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    //onlyIfEmpty: o servidor só grava se json_fund_infos estiver vazio, devolvendo 409 caso
    //contrário. Usado pela atualização em massa; os fluxos que precisam sobrescrever omitem.
    async updateInfosLocalQuotasByFundId(fund_id, infos, month, year, onlyIfEmpty) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/fund_local_quotas/updateInfosLocalQuotasByFundId', {
                fund_id: fund_id,
                infos: infos,
                month: month,
                year: year,
                only_if_empty: onlyIfEmpty === true,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLocalQuotaByFundId(fundId, date) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getLocalQuotaByFundId', {
                fund_id: fundId,
                date: date,
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLocalFundInfoById(fundLocalQuotaiId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/fund_local_quotas/getLocalFundInfoById/' + fundLocalQuotaiId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLastLocalFundInfoByFundId(fundId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/fund_local_quotas/getLastLocalFundInfoByFundId/' + fundId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLocalFundInfoByCnpj(cnpj, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/fund_local_quotas/getLocalFundInfoByCnpj', {
                cnpj, month, year
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllLocalQuotasByFundId(fundId) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/fund_local_quotas/getAllLocalQuotasByFundId/' + fundId, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllLocalQuotasByFundIdMonthAndYear(fundId, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getAllLocalQuotasByFundIdMonthAndYear',
                {
                    fund_id: fundId,
                    month: month,
                    year: year
                }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLocalQuotasByFundMonthYear(fundId, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getLocalQuotasByFundMonthYear', { fund_id: fundId, month: month, year: year }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLocalInfosByFundIdMonthYear(fundId, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getLocalInfosByFundIdMonthYear', { fund_id: fundId, month: month, year: year }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    //Fundos da carteira do cliente com mais de uma linha de cotas locais no mesmo mês/ano.
    //Cobre o mês informado e o anterior (a query de ativos joina fund_local_quotas nos dois).
    async getDuplicatedLocalQuotasByClient(clientId, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getDuplicatedLocalQuotasByClient', {
                client_id: clientId,
                month: month,
                year: year
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },
    async getLocalInfosByArrayFundsIds(arrayFundsIds, month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getLocalInfosByArrayFundsIds', {
                array_funds_ids: arrayFundsIds,
                month: month,
                year: year
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    //Usando como referência o fundo 11.328.882/0001-35 BB IRF-M 1 TP FIC RF PREVID
    async getLastDayQuotaInMonth(month, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getLastDayQuotaInMonth', { month: month, year: year }, config)
            console.log("RESPONSE: ", response);
            return {
                success: true,
                body: response.data.lastDay
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLocalQuotasByFundsIdsAndYear(arrayFundsIds, year) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getLocalQuotasByFundsIdsAndYear', {
                funds_ids: arrayFundsIds,
                year: year
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getLocalQuotasByFundIdAndPeriods(fundId, periods) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/fund_local_quotas/getLocalQuotasByFundIdAndPeriods', {
                fund_id: fundId,
                periods: periods
            }, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },
}
